import { PropertiesRequestTypes } from './types';
import { PropertiesActions } from './actions';
import { createRequestReducer } from '@fullstory/redux-util';
import { combineReducers } from 'redux';
import { GetAllPropertiesResponse, PropertyDetail } from '@fullstory/proto/fs/services/dx-objects';

type State = Map<string, PropertyDetail>;

function properties(
  state: State = new Map<string, PropertyDetail>(),
  action: PropertiesActions,
): State {
  switch (action.type) {
    case PropertiesRequestTypes.GetAllPropertiesSuccess: {
      const newState = new Map(state);
      action.data.properties.forEach(property => {
        newState.set(property.id, property);
      });
      return newState;
    }
    case PropertiesRequestTypes.GetPropertySuccess: {
      const newState = new Map(state);
      if (action.data.property) {
        newState.set(action.data.property.id, action.data.property);
      }
      return newState;
    }

    default:
      return state;
  }
}

export const getAllProperties = createRequestReducer<GetAllPropertiesResponse>()(
  PropertiesRequestTypes.GetAllPropertiesRequest,
  PropertiesRequestTypes.GetAllPropertiesSuccess,
  PropertiesRequestTypes.GetAllPropertiesFailure,
);

type PropertiesReducerState = {
  properties: ReturnType<typeof properties>;
  getAllProperties: ReturnType<typeof getAllProperties>;
};

export const propertiesReducer = combineReducers<PropertiesReducerState>({
  properties,
  getAllProperties,
});
